import React, { useEffect } from 'react';
import { useStyles } from './style';
import {
  PageContainer,
  InputV2,
  SelectV,
  ButtonLoading,
  SimpleDialog,
  Icons,
  PriceLabel,
  NumberToPersianWords,
  InputCurrency
} from 'components';
import Skeleton from '@mui/material/Skeleton';
import createToast from 'components/Toast/Toast';
import { deleteNullValueFromObj, constBreadCrumbsTitle } from 'utility';
import {
  Grid,
  Button,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  IconButton,
} from '@mui/material';
import useCustomHook from './hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams, useNavigate } from 'react-router-dom';
import TransferCreditServices from '../services';
import { useCurrencyUnit } from 'hooks';

export default function CartableTransferCredit() {
  const grantTypeOptions = [
    {
      value: 'cellphoneNumber',
      label: 'تلفن همراه',
      rules: ['isMobile'],
      englishNumber: true,
    },
    {
      value: 'username',
      label: 'نام کاربری',
      rules: ['isUsername'],
      englishNumber: true,
    },
    {
      value: 'email',
      label: 'پست الکترونیک',
      rules: ['isEmail'],
      englishNumber: true,
    },
  ];
  const paramsUrl = useParams();
  const navigate = useNavigate();
  const typeOfMethod = navigate?.location?.state?.group?.multiConfirmationSrv?.guildSrv
    ? 'guild'
    : navigate?.location?.state?.group?.multiConfirmationSrv?.wallet
    ? 'wallet'
    : '';
  const classes = useStyles();
  const {
    isPageLoading,
    setIsPageLoading,
    grantUserDataType,
    setGrantUserDataType,
    captchaLoading,
    setCaptchaLoading,
    captchaId,
    setCaptchaId,
    enteredCaptcha,
    setEnteredCaptcha,
    captchaImg,
    setCaptchaImg,
    isLoading,
    setIsLoading,
    foundUser,
    setFoundUser,
    isConfirmModalOpen,
    setIsConfirmModalOpen,
    currentUserId,
    setCurrentUserId,
    amount,
    setAmount,
    isTransferLoading,
    setIsTransferLoading,
  } = useCustomHook();
  const methods = useForm();
  const { handleSubmit, control, register, formState: { errors } } = methods;
  const currencyText = useCurrencyUnit();

  useEffect(() => {
    makeCaptcha();
  }, []);
  const resetFields = () => {};
  const goToList = (accountId) => {
    window.location.assign(`/CartableRequest/List`);
  };

  const makeCaptcha = async () => {
    setCaptchaLoading(true);
    setEnteredCaptcha('');
    try {
      const r = await TransferCreditServices.getCaptcha();

      setCaptchaId(r?.result?.captchaId);
      setCaptchaImg(r?.result?.captchaImg);

      setCaptchaLoading(false);
    } catch (error) {
      setCaptchaLoading(false);
    }
  };
  const onTransfer = () => {
    const values = methods.getValues();
    setIsTransferLoading(true);
    let data = {
      requestDescription: null,
      amount: amount,
      currencyCode: 'IRR',
      description: values?.description || null,
      verificationNeeded: null,
      uniqueId: null,
    };
    if (typeOfMethod === 'guild') {
      data['guildCode'] = navigate.location.state.group?.multiConfirmationSrv?.guildSrv?.code;
      data['userId'] = foundUser?.linkedUser?.id;
      deleteNullValueFromObj(data);
      TransferCreditServices.transferCreditContactWitGuild(paramsUrl?.id, data)
        .then((res) => {
          createToast('موفق', 'عملیات با موفقیت انجام شد.', 'success');

          setIsConfirmModalOpen(false);
          goToList();
        })
        .catch((error) => {
          setIsConfirmModalOpen(false);
          setIsTransferLoading(false);
        });
    } else if (typeOfMethod === 'wallet') {
      data['wallet'] = navigate.location.state.group?.multiConfirmationSrv?.wallet?.code;
      data['contactId'] = foundUser?.id;
      deleteNullValueFromObj(data);
      TransferCreditServices.transferCreditContactWithWallet(paramsUrl?.id, data)
        .then((res) => {
          createToast('موفق', 'عملیات با موفقیت انجام شد.', 'success');
          setIsConfirmModalOpen(false);
          goToList();
        })
        .catch((error) => {
          setIsConfirmModalOpen(false);
          setIsTransferLoading(false);
        });
    } else {
      setIsConfirmModalOpen(false);
      setIsTransferLoading(false);
    }
  };

  const onCheckContact = async (data) => {
    setIsLoading(true);
    try {
      const body = {
        firstName: data?.firstName || null,
        lastName: data?.lastName || null,
      };
      body[data?.type] = data?.contact;
      const r = await TransferCreditServices.checkContact(body);
      if (r.result?.length > 0) {
        if (r.result[0]?.linkedUser?.id === currentUserId) {
          createToast('خطا', 'امکان انتقال وجه به خودتان وجود ندارد!', 'danger');

          setIsLoading(false);
          return;
        }
        setAmount(data?.amount ?? null);
        setFoundUser(r.result[0]);
        setIsConfirmModalOpen(true);
      } else {
        createToast('خطا', 'کاربری با این اطلاعات یافت نشد!', 'danger');

        return;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      return;
    }
  };
  const handleCloseModal = () => {
    setIsConfirmModalOpen(false);
    setFoundUser(null);
  };

  const hintText =
    'در این بخش شما می‌توانید وجه نقد حساب های چند امضایی خود را به کاربر دیگری انتقال دهید.';
  return (
    <PageContainer
      title="انتقال وجه"
      className={classes.root}
      description={hintText}
      breadcrumbs={constBreadCrumbsTitle.CARTABLE_TRANSFER_CREDIT}
      loading={isPageLoading}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onCheckContact)} className={classes.form} autocomplete="off">
          <Grid container spacing={2} xs={8}>
            <Grid item xs={12} md={6}>
              <SelectV
                name="type"
                options={grantTypeOptions}
                label="نوع اطلاعات مخاطب"
                control={control}
                register={register}
                rules={['required']}
                required
                onChangeFunc={(k, e) => {
                  setGrantUserDataType(e?.target?.value);
                }}
                defaultValue={grantUserDataType}
                errors={errors}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputV2
                control={control}
                register={register}
                errors={errors}
                rules={[
                  'required',
                  ...grantTypeOptions.find((v) => v?.value === grantUserDataType)?.rules,
                ]}
                englishNumber={
                  grantTypeOptions.find((v) => v?.value === grantUserDataType)?.englishNumber
                }
                name="contact"
                label={grantTypeOptions.find((v) => v?.value === grantUserDataType)?.label}
                mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                fullWidth
                dir="ltr"
                placeholder=""
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} xs={8}>
            <Grid item xs={12} md={6}>
              <InputCurrency
                control={control}
                register={register}
                errors={errors}
                fullWidth
                label="مبلغ"
                name="amount"
                dir="ltr"
                onChangeValue={(v) => setAmount(v)}
                decimalPlaces={0}
                minimumValue={0}
                rules={['required']}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputV2
                control={control}
                register={register}
                errors={errors}
                name="description"
                label="محل مصرف"
                mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                fullWidth
                placeholder=""
                defaultValue={null}
              />
            </Grid>
          </Grid>
          <Grid container alignItems="flex-end" xs={12} md={4} lg={3}>
            <Grid item>
              {!captchaLoading && captchaImg ? (
                <img
                  alt="captcha"
                  src={'data:image/jpeg;base64,' + captchaImg}
                  className={classes.captcha}
                />
              ) : (
                <Skeleton variant="text" className={classes.captchaLoading} />
              )}
            </Grid>
            <Grid item>
              <IconButton tabIndex={-1} onClick={makeCaptcha} size="large">
                <Icons icon="Refresh" color="#b5b5b5" size="18" />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container spacing={8}>
            <Grid item xs={12} md={4} lg={2} spacing={2}>
              <InputV2
                errors={{}}
                name="captchaAnswer"
                label="کد امنیتی"
                forceValue={enteredCaptcha}
                onChangeValue={(e) => setEnteredCaptcha(e?.target?.value ?? '')}
                englishNumber
                rules={['required']}
                dir="ltr"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} xs={12} style={{ marginTop: 8 }} justifyContent="flex-end">
            <Grid item>
              <ButtonLoading
                name="انتقال وجه"
                loading={isLoading}
                variant="contained"
                color="primary"
                type="submit"
              />
            </Grid>
          </Grid>
        </form>
      </FormProvider>
      <SimpleDialog
        title="انتقال وجه با جزئیات زیر انجام گیرد؟"
        open={isConfirmModalOpen}
        icon={<Icons icon="UserIDCard" color="#2B3990" size="25" />}
        onClose={handleCloseModal}
        actions={
          <>
            <ButtonLoading
              name="تایید"
              onClick={onTransfer}
              loading={isTransferLoading}
              variant="contained"
              color="primary"
            />
            <Button onClick={handleCloseModal} variant="contained">
              انصراف
            </Button>
          </>
        }
      >
        <TableContainer className={classes.tableContainer}>
          <Table className={classes.table} aria-label="simple table">
            <TableBody>
              <TableRow>
                <TableCell className={classes.titleCell} component="th" scope="row">
                  نام
                </TableCell>
                <TableCell>
                  {foundUser?.linkedUser?.name ??
                    `${!foundUser?.firstName && !foundUser?.lastName ? '-' : ''}${
                      foundUser?.firstName ?? ''
                    } ${foundUser?.lastName ?? ''}`}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.titleCell} component="th" scope="row">
                  مبلغ
                </TableCell>
                <TableCell>
                  <Typography className={classes.boldCell}>
                    <PriceLabel amount={amount} currency={currencyText}/>
                  </Typography>
                  <Typography className={classes.subTitleData}>
                    <NumberToPersianWords number={amount} />
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </SimpleDialog>
    </PageContainer>
  );
}
